import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { AuthService } from "src/app/core/auth/auth.service";
import { StorageService } from "src/app/core/helpers/storage-Service";
import { Invoice, PaymentRequest } from "src/app/core/models/model";
import { PaymentService } from "src/app/pages/shared/services/payment.service";

@Component({
  selector: "app-invoice-payment",
  templateUrl: "./invoice-payment.component.html",
  styleUrls: ["./invoice-payment.component.scss"],
  standalone: false
})
export class InvoicePaymentComponent implements OnInit {
  invoiceCode: string;
  destroy$ = new Subject();

  invoice: Invoice;
  totalAmount: number = 0;

  rand: number;
  constructor(
    private paymentService: PaymentService,
    private route: ActivatedRoute,
    private router: Router,
    private authService: AuthService,
    private storageService: StorageService,
  ) {}

  ngOnInit() {
    this.invoiceCode = this.route.snapshot.params.code;
    this.getInvoice();
  }

  getRand() {
    this.rand = Math.floor(Math.random() * 900);
    return `${Date.now().toString()}${this.rand}`;
  }

  getInvoice() {
    this.paymentService
      .getInvoice(this.invoiceCode)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res) => {
          this.invoice = res;
          if (this.invoice) {
            this.totalAmount = this.invoice.products.reduce(
              (sum, product) => sum + product.price * product.quantity,
              0
            );
          };

          if (this.route.snapshot.url.toString().includes("invoice")) {
            const id = this.route.snapshot.url.toString().split(',').pop();
            this.getCheckoutToken("invoice", res.clientId, id);
          }
        },
        error: (err) => console.log(err),
      });
  }

  getCheckoutToken(
    entityType?: string,
    clientId?: string,
    reference: string = "123",
  ) {
    return this.authService
      .getAccessControl(entityType, clientId, reference)
      .subscribe((res) => {
        this.storageService.saveAccessToken(res["token"]);
      });
  }

  makePayment() {
    const payload: PaymentRequest = {
      reference: this.getRand(),
      userId: this.invoice.customerEmail,
      amount: this.totalAmount,
      currency: "NGN",
      metadata: {
        email: this.invoice.customerEmail,
      },
      clientId: this.invoice.clientId,
    };
    this.paymentService
      .createPayment(payload)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res) => {
          if (res["status"] === "CREATED") {
            this.router.navigate(["pay", res["paymentUrlReference"]]);
          }
        },
      });
  }
}
